import GenericNewCategoryPage from './GenericNewCategoryPage';

function DigitalDuniya() {
  return <GenericNewCategoryPage categoryId={15} categoryKey="digitalDuniya" />;
}

export default DigitalDuniya;
